/* eslint-disable no-restricted-imports */
import { createPlugin } from '../../../Fct/createPlugin';
import { FctAnyType, FctString } from '../../../Fct/generics';
export var SetParam = createPlugin({
    protocol: 'FUNCTIONS',
    type: 'GETTER',
    method: 'setParam',
    name: 'setParam',
    flowType: 'OFFCHAIN_ONLY',
    getParams: function () { return ({
        input: {
            key: new FctString({}),
            param: new FctAnyType({ required: false }),
            methodParams: {},
        },
        output: {},
    }); },
});
